export const sportsCategories = [
  { id: "soccer", icon: "ri-football-line", label: "축구", color: "bg-primary-500" },
  { id: "baseball", icon: "ri-base-station-line", label: "야구", color: "bg-accent-500" },
  { id: "basketball", icon: "ri-basketball-line", label: "농구", color: "bg-secondary-500" },
  { id: "volleyball", icon: "ri-medal-line", label: "배구", color: "bg-primary-400" },
  { id: "hockey", icon: "ri-riding-line", label: "하키", color: "bg-accent-400" },
];

export const soccerNews = [
  { id: 1, title: "2026 월드컵 조별리그 C조 전력 분석: 노르웨이의 창과 프랑스의 방패", source: "스포츠분석팀", time: "2026-07-01", views: 2345, category: "축구" },
  { id: 2, title: "EPL 26-27 시즌 개막 전 프리뷰: 빅6 전력 변화 총정리", source: "프리미어리그분석", time: "2026-06-30", views: 1876, category: "축구" },
  { id: 3, title: "K리그 여름 이적시장: 주요 팀들의 영입 현황과 전망", source: "K리그분석", time: "2026-06-29", views: 1234, category: "축구" },
  { id: 4, title: "챔피언스리그 결승 리뷰: 전술적 승부의 모든 것", source: "전술분석", time: "2026-06-28", views: 3456, category: "축구" },
];

export const baseballNews = [
  { id: 5, title: "KBO 후반기 순위 전망과 주요 변수 분석", source: "야구분석팀", time: "2026-06-30", views: 1567, category: "야구" },
  { id: 6, title: "MLB 올스타전 로스터 발표: 올해의 깜짝 선발은?", source: "MLB분석", time: "2026-06-29", views: 987, category: "야구" },
];

export const basketballNews = [
  { id: 7, title: "NBA FA 시장 오픈: 빅네임들의 행선지는?", source: "NBA분석", time: "2026-07-01", views: 2890, category: "농구" },
  { id: 8, title: "KBL 신인 드래프트 결과 분석: 각 팀별 픽 평가", source: "KBL분석", time: "2026-06-28", views: 876, category: "농구" },
];

export const volleyballNews = [
  { id: 9, title: "V-리그 여자부 FA 시장 결산: 전력 지형도 변화", source: "배구분석팀", time: "2026-06-27", views: 1234, category: "배구" },
  { id: 10, title: "FIVB 네이션스리그 한국 대표팀 분석", source: "국제배구분석", time: "2026-06-25", views: 654, category: "배구" },
];

export const hockeyNews = [
  { id: 11, title: "NHL 스탠리컵 결승 시리즈 전망과 키플레이어 분석", source: "NHL분석", time: "2026-07-01", views: 1123, category: "하키" },
  { id: 12, title: "2026-27 NHL 시즌 파워랭킹: 각 디비전 우승 후보는?", source: "하키분석팀", time: "2026-06-29", views: 890, category: "하키" },
];